<template v-if="items">
  <div class="attachments">
    <div class="common-table">
      <div v-if="isDataMissing && !isEditMode" class="attachments__missing-data">
        <span>There are no attachments here yet.</span>
      </div>
      <div v-else-if="!isEditMode" class="attachments__table-body">
        <AttachmentItem v-for="item of items"
                        :key="getItemKey(item)"
                        :attachment="item"
                        :removeIds="removeIds"
                        :isPublishTab="isPublishTab"
                        @update="onUpdate"
                        @remove="handleRemove(item)"/>
      </div>
      <template v-if="isEditMode">
        <div ref="addNewAttachment" class="attachments__add-new">
          <div class="attachments__add-new_row">
            <template v-if="isFileType">
              <base-material-design-icon
                class="icon icon__type"
                icon="plus"/>
              <input v-if="!updateAttachment"
                     :disabled="disableButtons"
                     @change="fileChange($event.target.files[0])"
                     class="attachments__add-new_input attachments__add-new_input_file"
                     type="file">
              <span v-else class="attachments__add-new_input">{{ link }}</span>
            </template>
            <template v-else>
              <base-material-design-icon
                class="icon icon__type"
                icon="insertLink"/>
              <input placeholder="Paste link here"
                     v-model="link"
                     :disabled="disableButtons"
                     :class="{ 'attachments__add-new_input_err': errorFields.includes('link') }"
                     class="attachments__add-new_input attachments__add-new_input_link"
                     type="text">
            </template>
          </div>
          <template v-if="isPublishTab" >
            <div class="attachments__add-new_row">
              <input placeholder="Name"
                     v-model="image_name"
                     :disabled="disableButtons"
                     :class="{ 'attachments__add-new_input_err': errorFields.includes('image_name') }"
                     class="attachments__add-new_input attachments__add-new_input_name"
                     type="text">
            </div>
            <div class="attachments__add-new_row">
              <input placeholder="Img Alt"
                     v-model="image_name_alt"
                     :disabled="disableButtons"
                     class="attachments__add-new_input attachments__add-new_input_alt_name"
                     type="text">
            </div>
          </template>
          <div v-else class="attachments__add-new_row">
            <base-material-design-icon
              class="icon icon__type icon__desc"
              icon="description"/>
            <textarea placeholder="Description"
                      :disabled="disableButtons"
                      v-model="desc"
                      :class="{ 'attachments__add-new_input_err': errorFields.includes('desc') }"
                      class="attachments__add-new_input attachments__add-new_input_description"
                      type="text"></textarea>
          </div>
        </div>
        <div class="attachments__add-new_footer">
          <button @click.prevent.stop="onCancel" :disabled="disableButtons" class="cancel-button">Cancel</button>
          <button @click.prevent.stop="handleSave" :disabled="disableButtons || disableSaveButton" class="update-button">Save</button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { isInViewport } from './Helper'
import AttachmentItem from './AttachmentItem'
// eslint-disable-next-line no-unused-vars
import ContentBrief from './index'
import { mapActions } from 'vuex'

const TYPE = {
  FILE: 'file',
  LINK: 'link'
}
/**
 * Modal with list of Content Brief attachments for both attachment types: file and link
 * Used in {@link ContentBrief}
 */
export default {
  name: 'Attachments',
  components: {
    AttachmentItem
  },
  props: ['attachments', 'isAddNewAttachment', 'briefId', 'addNewType', 'isPublishTab'],
  data () {
    return {
      items: [],
      disableButtons: false,
      file: null,
      errorFields: [],
      removeIds: [],
      link: '',
      desc: '',
      image_name: '',
      image_name_alt: '',
      updateAttachment: null
    }
  },
  computed: {
    isFileType () {
      return this.addNewType === 'file'
    },
    isDataMissing () {
      return !this.items || !this.items.length
    },
    disableSaveButton () {
      if (this.isPublishTab) {
        return !this.image_name || !this.image_name.length || !this.link || !this.link.length
      }
      return !this.isFileType || this.updateAttachment ? !this.link || !this.link.length : !this.file
    },
    isEditMode () {
      return this.isAddNewAttachment || this.updateAttachment
    }
  },
  watch: {
    isAddNewAttachment: {
      handler () {
        if (this.updateAttachment) {
          Object.assign(this, {
            updateAttachment: null,
            link: '',
            desc: '',
            image_name: '',
            image_name_alt: ''
          })
        }
        this.$nextTick(() => {
          if (this.$refs.addNewAttachment) {
            if (!isInViewport(this.$refs.addNewAttachment)) {
              this.$refs.addNewAttachment.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }
        })
      },
      immediate: true
    },
    isFileType () {
      this.file = null
      !this.updateAttachment && (this.link = '')
      this.errorFields = []
    },
    attachments: {
      handler () {
        this.items = this.convertPropsToInternalItemsArray()
      },
      immediate: true,
      deep: false
    },
    updateAttachment() {
      this.$emit('changeUpdateState', !!this.updateAttachment)
    }
  },
  methods: {
    ...mapActions('briefContent', ['addNewAttachment', 'removeAttachment']),
    convertArrayIntoObject (array) {
      const result = {}
      array.forEach(elem => Object.assign(result, elem))
      return result
    },
    /**
     * prepare received data for list
     * @returns Array
     */
    convertPropsToInternalItemsArray: function () {
      if (!this.attachments || this.attachments.length === 0) {
        return
      }
      return this.attachments.map((attachment, index) => {
        if (Array.isArray(attachment)) {
          attachment = this.convertArrayIntoObject(attachment)
        }
        if (!attachment.file && !attachment.link) {
          return
        }
        const item = {}
        if (attachment.file) {
          item.type = TYPE.FILE
          item.link = attachment.file
          let splitedLink = attachment.file.split('/')
          item.name = _.capitalize(splitedLink[ splitedLink.length - 1 ])
          item.actionIcon = 'download'
        } else {
          item.type = TYPE.LINK
          item.link = attachment.link
          item.name = attachment.link
          item.actionIcon = 'external-link-alt'
        }
        item.label = attachment.label
        item.description = attachment.description
        item.expanded = false
        item.id = attachment._id
        item.image_name = attachment.image_name
        item.image_name_alt = attachment.image_name_alt
        return item
      }).filter(item => item)
    },
    async handleRemove (item) {
      if (item) {
        this.$emit('changeRemovingState', true)
        const id = item.id
        this.removeIds.push(id)
        const isSuccesfull = await this.removeAttachment(id)
        this.$emit('changeRemovingState', false)
        if (isSuccesfull) {
          this.onCancel(true)
        } else {
          const index = this.removeIds.findIndex(v => v === id)
          this.removeIds.splice(index, 1)
        }
      }
    },
    fileChange (file) {
      this.file = file
    },
    onCancel (isUpdate = false) {
      this.link = ''
      this.desc = ''
      this.image_name = ''
      this.image_name_alt = ''
      if (this.updateAttachment) {
        this.updateAttachment = null
        this.addNewType = ''
        this.$emit('attachmentUpdated')
      } else {
        this.$emit('addNewChange', isUpdate)
      }
    },
    handleSave () {
      this.updateAttachment ? this.updateAttachmentData() : this.onSave()
    },
    onUpdate (data) {
      data = _.cloneDeep(data)
      this.addNewType = data.type
      this.link = data.type === 'file' ? data.label : data.link
      this.desc = data.description
      this.image_name = data.image_name
      this.image_name_alt = data.image_name_alt
      this.updateAttachment = data
    },
    updateAttachmentData () {
      const { link = '', desc = '', image_name = '', image_name_alt = '' } = this

      const errorFields = []

      if (!link.length) {
        errorFields.push('link')
      }
      if (this.isPublishTab && !image_name.length) {
        errorFields.push('image_name')
      }

      this.errorFields = errorFields

      if (errorFields.length) {
        return
      }
      const data = {
        link,
        desc,
        image_name,
        image_name_alt,
        isFileType: false,
        method: 'patch',
        id: this.updateAttachment.id
      }
      this.onSave(data)
    },
    async onSave (data = this) {
      const { file, link, desc, image_name, image_name_alt, isFileType, method = 'post', id = 0 } = data

      const errors = []

      if (isFileType) {
        if (!file) {
          errors.push('file')
        }
      } else {
        if (!link || typeof link !== 'string' || !link.length) {
          errors.push('link')
        }
        if (this.isPublishTab && (!image_name || typeof image_name !== 'string' || !image_name.length)) {
          errors.push('image_name')
        }
      }
      this.errorFields = errors
      if (errors.length) {
        return
      }

      this.disableButtons = true

      const form = new FormData()
      file && form.append('file', file, file.name)
      form.append('is_file_upload', isFileType ? 1 : 0)
      form.append('desc', desc)
      form.append('id', id)
      form.append('link', link)
      form.append('image_name', image_name)
      form.append('image_name_alt', image_name_alt)
      form.append('is_publish_tab', this.isPublishTab)
      await this.addNewAttachment({
        briefId: this.briefId,
        method: method,
        data: form,
        successMessage: method === 'patch' ? 'Attachment updated successfully' : 'Attachment added successfully'
      })

      this.file = null
      this.desc = ''
      this.link = ''
      this.image_name = ''
      this.image_name_alt = ''
      this.disableButtons = false
      this.updateAttachment = null

      this.onCancel(true)
    },
    // can't use item.id as a key because link change won't be reflected in template
    getItemKey(item) {
      return item.id + item.link
    }
  }
}
</script>
<style scoped lang="scss">
  @import '../../../assets/variables';

  .common-table {
    height: 100%;
    overflow-y: scroll;
  }

  .attachments {
    background: #fff;
    height: 230px;
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    &__missing-data {
      color: #7a8894;
      display: flex;
      width: -webkit-fill-available;
      height: 203px;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      span {
        height: fit-content;
      }
    }

    .update-button {
      text-transform: uppercase;
      color: white;
      width: 100px;
      font-size: 10px;
      font-weight: 900;
      height: 40px;
      border-radius: 4px;
      background-color: $rfx-medium-march;
      border: none;

      &:disabled {
        opacity: .4;
      }
    }

    .cancel-button {
      @extend .update-button;
      color: $rfx-dark-march;
      border-radius: 4px;
      background-color: white;
      position: inherit;
      border: none;
      margin-left: auto;
      margin-right: 30px;

      &:disabled {
        opacity: .4;
      }
    }

    &__add-new {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: white;

      &_row {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #dbdee5;
        width: -webkit-fill-available;
      }

      &_input {
        border: none;
        outline: none;
        color: $rfx-blue;
        font-size: 14px;
        line-height: 20px;
        background-color: transparent;

        &_file {
          margin-right: 19.3%;
        }

        &_link {
          width: -webkit-fill-available;
        }

        &_description {
          color: #011627;
          resize: none;
          height: 66px;
          width: -webkit-fill-available;
        }

        &::placeholder {
          color: #7a8894;
        }

        &_err {
          color: $rfx-light-red;

          &::placeholder {
            color: $rfx-light-red;
          }
        }
      }

      &_footer {
        padding: 24px 24px 24px 0;
        display: flex;
      }
    }

    &__title {
      height: 80px;
      font-size: 34px;
      font-weight: 500;
      text-align: center;
    }

    &__table-body {
      height: 100%;
    }

    &__header {
      background: rgba(1,22,39,.1);
      border-radius: 4px 4px 0 0;

      &-description,
      &-name {
        font-size: 14px;
        color: $rfx-dark-march;
      }

      &-name {
        padding-left: 55px;
        box-sizing: border-box;
        flex: 0 0 40%;
      }

      &-description {
        flex: 0 0 60%;
      }
    }

    .icon {
      display: inline-block !important;
      color: $rfx-blue;
      font-size: 18px;

      &__desc {
        color: #011627;
        margin-bottom: auto;
        margin-top: 4px;
      }

      &__type {
        margin-right: 13px;
      }

      &_clickable {
        cursor: pointer;
      }
    }
  }

  .button {
    &__wrapper {
      text-align: end;
      margin-top: 30px;
    }

    &__close {
      width: 70px;
      height: 40px;
      background-color: $rfx-dark-march;
      color: #fff;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-align: center;
      cursor: pointer;
      outline: none;
    }
  }
</style>
